/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_asciiToArray.js
// module id = 1085
// module chunks = 0